import { useCallback } from 'react';

import { useAuth } from './useAuth';

export const useAncestryLogout = () => {
  const { onLogout } = useAuth();

  return useCallback(() => {
    onLogout();
  }, [onLogout]);
};
